import React, { useEffect, useState } from 'react'
import styles from './index.module.sass'
import { Search } from '../../ui/Search'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'
import '../../../styles/tabs.sass'
import prev from '../../../assets/arrow_prev.svg'
import next from '../../../assets/arrow_next.svg'
import { Block } from '../../../app/models/generated'
import classNames from 'classnames'
import ProgressBar from '../../ui/ProgressBar'
import { NavLink, useNavigate, useParams } from 'react-router-dom'
import { initialBlock } from '../../../app/models/generated/models/Block'
import {
    calculateReward,
    formatNumber,
    getTimeFromTimestamp,
} from '../../../utils'
import { TransactionItems } from '../TransactionsPage/TransactionItems'
import { TransactionList } from '../../../services/TransactionsPageService'
import { getBlock, getTransactions } from '../../../services/BlockPageService'
import { Icon } from '../../ui/Icon'

const previousParams: Record<string, string>[] = []
let currentParams: Record<string, string> = {}
let page = 1

export const BlockPage = () => {
    const navigate = useNavigate()
    const { number } = useParams()
    const [block, setBlock] = useState<Block>(initialBlock)
    useEffect(() => {
        getBlock(setBlock, number, navigate)
    }, [])
    const [transactionList, setTransactions] = useState<TransactionList>({
        items: [],
        next_page_params: null,
    })
    useEffect(() => {
        getTransactions(setTransactions, number, {})
    }, [])

    const isDisabled = page == 1

    const previousPageHandler = () => {
        if (previousParams.length > 0) {
            page = page - 1
            currentParams = previousParams.pop() || {}
            getTransactions(setTransactions, number, currentParams)
        }
    }
    const nextPageHandler = () => {
        if (transactionList.next_page_params) {
            previousParams.push(currentParams)
            currentParams = transactionList.next_page_params
            page = page + 1
            getTransactions(setTransactions, number, currentParams)
        }
    }

    const gasUsedPercentage = block.gas_used_percentage
        ? Number(block.gas_used_percentage.toFixed(2))
        : 0
    const gasTargetPercentage = block.gas_target_percentage
        ? Number(block.gas_target_percentage.toFixed(2))
        : 0
    const baseFeePerGas = block.base_fee_per_gas
        ? (block.base_fee_per_gas / 10 ** 18).toFixed(18)
        : 0
    const burntFees = block.burnt_fees
        ? (block.burnt_fees / 10 ** 18).toFixed(18)
        : 0
    const burntFeesPercentage = block.burnt_fees_percentage
        ? Number(block.burnt_fees_percentage.toFixed(2))
        : 0
    const priorityFee = block.priority_fee
        ? (block.priority_fee / 10 ** 18).toFixed(18)
        : 0
    return (
        <div>
            <section className={styles.pageSection}>
                <div className={styles.headOfPage}>
                    <p>Block</p>
                    <p>#{block.height}</p>
                </div>
                <Tabs>
                    <TabList>
                        <Tab>Overview</Tab>
                        <Tab>Consensus Info</Tab>
                    </TabList>

                    <TabPanel>
                        <div className={styles.blockdetail}>
                            <div className={styles.details}>
                                <div className={styles.infoRow}>
                                    <span data-hint="The block height of a particular block is defined as the number of blocks preceding it in the blockchain">
                                        <Icon icon="infoSVG" width={24} height={24} color={"white"}/>
                                    </span>
                                    <p className={styles.rowTitle}>Block height: </p>
                                    <p>{block.height}</p>
                                </div>

                                <div className={styles.infoRow}>
                                    <span data-hint="Status value">
                                        <Icon icon="infoSVG" width={24} height={24} color={"white"}/>
                                    </span>
                                    <p className={styles.rowTitle}>Status: </p>
                                    {/* <p>{block.height}</p> */}
                                    <p>Unfinalized (Safe)</p>
                                </div>

                                <div className={styles.infoRow}>
                                    <span data-hint="Date & time at which block was produced">
                                        <Icon icon="infoSVG" width={24} height={24} color={"white"}/>
                                    </span>
                                    <p className={styles.rowTitle}>Time Stamp: </p>
                                    {/* Change the value of timestamp */}
                                    {/* <p>{getTimeFromTimestamp(block.timestamp)}</p> */}
                                    <p>9 mins ago (Aug-10-2023 07:25:11 PM +UTC)</p>
                                </div>

                                <div className={styles.infoRow}>
                                    <span data-hint="Date & time at which block was produced">
                                        <Icon icon="infoSVG" width={24} height={24} color={"white"}/>
                                    </span>
                                    <p className={styles.rowTitle}>Proposed On: </p>
                                    {/* Make the value of Proposed On */}
                                    <p>Block proposed on slot 7072624, epoch 221019</p>
                                </div>

                                <div className={styles.infoRow}>
                                    <span data-hint="The number of transaction in block">
                                        <Icon icon="infoSVG" width={24} height={24} color={"white"}/>
                                    </span>
                                    <p className={styles.rowTitle}>Transactions: </p>
                                    <span>{block.tx_count}</span>
                                    <span className={styles.valueType}>
                                        {/* change the value of the transactions here 81 is the example */}
                                        transactions and 81 contract internal transactions in this block
                                    </span>
                                </div>
                                
                                <div className={styles.infoRow}>
                                    <span data-hint="Date & time at which block was produced">
                                        <Icon icon="infoSVG" width={24} height={24} color={"white"}/>
                                    </span>
                                    <p className={styles.rowTitle}>Withdrawals: </p>
                                    {/* Make the value of Withdrawals: */}
                                    <p>16 withdrawals in this block</p>
                                </div>
                                
                                <div className={styles.line}></div>

                                <div className={styles.infoRow}>
                                    <span data-hint="Date & time at which block was produced">
                                        <Icon icon="infoSVG" width={24} height={24} color={"white"}/>
                                    </span>
                                    <p className={styles.rowTitle}>Fee Recipient: </p>
                                    {/* Make the value of Fee Recipient:: */}
                                    <p>beaverbuild in 12 secs</p>
                                </div>

                                <div className={styles.infoRow}>
                                    <span data-hint="For each block, the validator is rewarded with a finite amount of THE on top of the fees paid for all transactions in the block">
                                        <Icon icon="infoSVG" width={24} height={24} color={"white"}/>
                                    </span>
                                    <p className={styles.rowTitle}>Block Reward:</p>
                                    <span>
                                        {/* check the value again */}
                                        {calculateReward(block.rewards) / 10 ** 18}
                                    </span>
                                    <span className={styles.valueType}>ETH (0 + 0.638395712898148107 - 0.54811550137414092)</span>
                                </div>

                                <div className={styles.infoRow}>
                                    <span data-hint="Date & time at which block was produced">
                                        <Icon icon="infoSVG" width={24} height={24} color={"white"}/>
                                    </span>
                                    <p className={styles.rowTitle}>Total Difficulty: </p>
                                    {/* Make the value of Total Difficulty */}
                                    <p>58,750,003,716,598,352,816,469</p>
                                </div>

                                <div className={styles.infoRow}>
                                    <span data-hint="Size of the block in bytes">
                                        <Icon icon="infoSVG" width={24} height={24} color={"white"}/>
                                    </span>
                                    <p className={styles.rowTitle}>Size: </p>
                                    {/* check the value again */}
                                    <p>{block.size} bytes</p>
                                </div>

                                <div className={styles.line}></div>

                                <div className={styles.infoRow}>
                                    <span data-hint="The total gas amount used in the block and its percentage of gas filled in the block">
                                        <Icon icon="infoSVG" width={24} height={24} color={"white"}/>
                                    </span>
                                    <p className={styles.rowTitle}>Gas used: </p>
                                    <span className={styles.mgR20}>
                                        {/* {formatNumber(block.gas_used)} */}
                                        22,025,740(73.42%) 
                                        <span className={styles.percentageGreen}> +47% Gas Target</span>
                                    </span>

                                    {/* previous code check the value again */}
                                    {/* <div className={styles.percentage}>
                                        <span>{gasUsedPercentage}%</span>
                                        <div className={styles.verticalLine}></div>
                                        <span>{gasTargetPercentage}%</span>
                                    </div> */}
                                </div>

                                <div className={styles.infoRow}>
                                    <span data-hint="Total gas limit provided by all transactions in the block">
                                        <Icon icon="infoSVG" width={24} height={24} color={"white"}/>
                                    </span>
                                    <p className={styles.rowTitle}>Gas limit: </p>
                                    <p>{formatNumber(block.gas_limit)}</p>
                                </div>

                                
                                <div className={styles.infoRow}>
                                    <span data-hint="Minimum fee required per unit of gas. Fee adjusts based on network congestion">
                                        <Icon icon="infoSVG" width={24} height={24} color={"white"}/>
                                    </span>
                                    <p className={styles.rowTitle}>
                                        Base fee per gas: 
                                    </p>
                                    <span>{baseFeePerGas}</span>
                                    {/* check the value again */}
                                    <span className={styles.valueType}>ETH (24.885225258 Gwei)</span>
                                </div>

                                <div className={styles.infoRow}>
                                    <span data-hint="Amount of THE burned from transactions included in the block. Equals Block Base Fee per Gas * Gas Used">
                                        <Icon icon="infoSVG" width={24} height={24} color={"white"}/>
                                    </span>
                                    <p className={styles.rowTitle}>Burnt fees: </p>
                                    <span>🔥{burntFees}</span>
                                    <span className={styles.valueType}>ETH</span>
                                    {/* <div className={styles.percentage}>
                                        <ProgressBar
                                            progressColor={'#59FFA4'}
                                            bgColor={'#8D8D8E'}
                                            progress={burntFeesPercentage}
                                            width={39}
                                            height={3}></ProgressBar>
                                        <span className={styles.percentageGreen}>
                                            {burntFeesPercentage}%
                                        </span>
                                    </div> */}
                                </div>

                                <div className={styles.infoRow}>
                                    <span data-hint="Date & time at which block was produced">
                                        <Icon icon="infoSVG" width={24} height={24} color={"white"}/>
                                    </span>
                                    <p className={styles.rowTitle}>Extra Data: </p>
                                    {/* Make the value of Extra Data */}
                                    <p>beaverbuild.org (Hex:0x6265617665726275696c642e6f7267)</p>
                                </div>

                                {/* previous code */}
                                {/* { <div className={styles.infoRow}>
                                    <span data-hint="A block producer who successfully included the block onto the blockchain">
                                        <Icon icon="infoSVG" width={24} height={24} color={"white"}/>
                                    </span>
                                    <p className={styles.rowTitle}>Validated by</p>
                                    <NavLink
                                        to={'/address/' + block.miner?.hash}
                                        className={styles.rowLink}>
                                        {block.miner?.hash}
                                    </NavLink>
                                </div>
                                }
                            
                                
                                <div className={styles.infoRow}>
                                    <span data-hint="User-defined tips sent to validator for transaction priority/inclusion">
                                        <Icon icon="infoSVG" width={24} height={24} color={"white"}/>
                                    </span>
                                    <p className={styles.rowTitle}>
                                        Priority fee / Tip
                                    </p>
                                    <span>{priorityFee}</span>
                                    <span className={styles.valueType}>ETH</span>
                                </div> */}
                            </div>
                            <div className={styles.details}>
                                <div className={styles.infoRow}>
                                    <span data-hint="The block height of a particular block is defined as the number of blocks preceding it in the blockchain">
                                        <Icon icon="infoSVG" width={24} height={24} color={"white"}/>
                                    </span>
                                    {/* Make the Hash value */}
                                    <p className={styles.rowTitle}>Hash: </p>
                                    <p>0x4c6f2ab72d31ace6f4bcb913b4491e1b8ca279fcd27b2f71cd6bd0531d14db5c</p>
                                </div>
                                <div className={styles.infoRow}>
                                    <span data-hint="The block height of a particular block is defined as the number of blocks preceding it in the blockchain">
                                        <Icon icon="infoSVG" width={24} height={24} color={"white"}/>
                                    </span>
                                    {/* Make the Parent Hash */}
                                    <p className={styles.rowTitle}>Parent Hash: </p>
                                    <p>0x61a8cad42b3d7a092bd7a8681280ba9663f0d618a0732ba77be913f61d30ba0e</p>
                                </div>

                                <div className={styles.infoRow}>
                                    <span data-hint="The block height of a particular block is defined as the number of blocks preceding it in the blockchain">
                                        <Icon icon="infoSVG" width={24} height={24} color={"white"}/>
                                    </span>
                                    {/* Make the StateRoot */}
                                    <p className={styles.rowTitle}>StateRoot: </p>
                                    <p>0x0e318dc40340d0529b3235188ca48bd59ed8a93692e925d0fb47b86f3dce25a8</p>
                                </div>

                                <div className={styles.infoRow}>
                                    <span data-hint="The block height of a particular block is defined as the number of blocks preceding it in the blockchain">
                                        <Icon icon="infoSVG" width={24} height={24} color={"white"}/>
                                    </span>
                                    {/* Make the WithdrawalsRoot */}
                                    <p className={styles.rowTitle}>WithdrawalsRoot: </p>
                                    <p>0x46dd24d9c8b935d3777813e902748287e699f08e8a942c79e2512af4aeaab7b5</p>
                                </div>

                                <div className={styles.infoRow}>
                                    <span data-hint="The block height of a particular block is defined as the number of blocks preceding it in the blockchain">
                                        <Icon icon="infoSVG" width={24} height={24} color={"white"}/>
                                    </span>
                                    {/* Make the Nonce */}
                                    <p className={styles.rowTitle}>Nonce: </p>
                                    <p>0x0000000000000000</p>
                                </div>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel>
                        <div className={styles.details}>
                            <div className={styles.infoRow}>
                                <span data-hint="The block height of a particular block is defined as the number of blocks preceding it in the blockchain">
                                    <Icon icon="infoSVG" width={24} height={24} color={"white"}/>
                                </span>
                                {/* Make the Slot value */}
                                <p className={styles.rowTitle}>Slot: </p>
                                <p>7072623</p>
                            </div>
                            <div className={styles.infoRow}>
                                <span data-hint="The block height of a particular block is defined as the number of blocks preceding it in the blockchain">
                                    <Icon icon="infoSVG" width={24} height={24} color={"white"}/>
                                </span>
                                {/* Make the Epoch */}
                                <p className={styles.rowTitle}>Epoch: </p>
                                <p>221019</p>
                            </div>
                            <div className={styles.infoRow}>
                                <span data-hint="The block height of a particular block is defined as the number of blocks preceding it in the blockchain">
                                    <Icon icon="infoSVG" width={24} height={24} color={"white"}/>
                                </span>
                                {/* Make the Proposer Index: */}
                                <p className={styles.rowTitle}>Proposer Index: </p>
                                <p>758184</p>
                            </div>

                            <div className={styles.line}></div>
                            
                            <div className={styles.infoRow}>
                                <span data-hint="The block height of a particular block is defined as the number of blocks preceding it in the blockchain">
                                    <Icon icon="infoSVG" width={24} height={24} color={"white"}/>
                                </span>
                                {/* Make the Slot Root Hash */}
                                <p className={styles.rowTitle}>Slot Root Hash: </p>
                                <p>0x39534f61767a80e1715f1ed181006a0b2e146d0827371c6e1a0d1743a58332cf</p>
                            </div>

                            <div className={styles.infoRow}>
                                <span data-hint="The block height of a particular block is defined as the number of blocks preceding it in the blockchain">
                                    <Icon icon="infoSVG" width={24} height={24} color={"white"}/>
                                </span>
                                {/* Make the Beacon Deposit Count */}
                                <p className={styles.rowTitle}>Beacon Deposit Count: </p>
                                <p>902188</p>
                            </div>

                            <div className={styles.infoRow}>
                                <span data-hint="The block height of a particular block is defined as the number of blocks preceding it in the blockchain">
                                    <Icon icon="infoSVG" width={24} height={24} color={"white"}/>
                                </span>
                                {/* Make the Slot Graffiti */}
                                <p className={styles.rowTitle}>Slot Graffiti: </p>
                                <div>🧱🔥 Kiln.fi 🔥<br/>(Hex:0xf09fa7b1f09f94a5204b696c6e2e666920f09f94a5f09fa7b100000000000000)</div>
                            </div>
                                
                            <div className={styles.infoRow}>
                                <span data-hint="The block height of a particular block is defined as the number of blocks preceding it in the blockchain">
                                    <Icon icon="infoSVG" width={24} height={24} color={"white"}/>
                                </span>
                                {/* Make the Block Randomness: */}
                                <p className={styles.rowTitle}>Block Randomness: </p>
                                <p>0xd13ec154525d2e8383c52779a0b64adbe8e0660bacf83f5c3a42a5a31c4a0d0d</p>
                            </div>

                            <div className={styles.infoRow}>
                                <span data-hint="The block height of a particular block is defined as the number of blocks preceding it in the blockchain">
                                    <Icon icon="infoSVG" width={24} height={24} color={"white"}/>
                                </span>
                                {/* Make the Randao Reveal */}
                                <p className={styles.rowTitle}>Randao Reveal: </p>
                                <p>0x91c3aed7a502ea6fbffdfbba93619a723af0d7cf708ef3cdf16d042eeb6d62b924b6580de6e6e<br/>f429b453b89e35560050c034146af13619964bd425fe81b019b4bda093216eecc5096557d0<br/>de558e55aa4ee9594e2a4363d11a6cc2c1d85f8d8</p>
                            </div>
                        </div>
                        {/* <div className={styles.transactions}>
                            <div className={styles.paginationButtons}>
                                <button
                                    className={styles.controlButton}
                                    disabled={isDisabled}
                                    onClick={previousPageHandler}>
                                    <img src={prev} alt="previous page" />
                                </button>
                                <div className={styles.pageNum}>{page}</div>
                                <button
                                    className={styles.controlButton}
                                    disabled={!transactionList.next_page_params}
                                    onClick={nextPageHandler}>
                                    <img src={next} alt="next page" />
                                </button>
                            </div>
                            <div className={styles.tableWrapper}>
                                <div className={styles.tableBorder}></div>
                                <table className={styles.table}>
                                    <thead className={styles.tableHead}>
                                        <tr>
                                            <th
                                                className={classNames(
                                                    styles.th20p75,
                                                    styles.thDefault
                                                )}>
                                                Txn hash
                                            </th>
                                            <th
                                                className={classNames(
                                                    styles.thType,
                                                    styles.thDefault
                                                )}>
                                                Type
                                            </th>
                                            <th
                                                className={classNames(
                                                    styles.thW15,
                                                    styles.thDefault
                                                )}>
                                                Method
                                            </th>
                                            <th
                                                className={classNames(
                                                    styles.thFrom,
                                                    styles.thDefault
                                                )}>
                                                From
                                            </th>
                                            <th className={styles.thIcon}></th>
                                            <th className={styles.thTo}>To</th>
                                            <th
                                                className={classNames(
                                                    styles.thW15,
                                                    styles.thDefaultRight
                                                )}>
                                                Value ETH
                                            </th>
                                            <th
                                                className={classNames(
                                                    styles.th20p75,
                                                    styles.thDefaultRight
                                                )}>
                                                Fee ETH
                                            </th>
                                        </tr>
                                    </thead>
                                    <TransactionItems
                                        TransactionArray={transactionList.items}
                                        currentLocation="BlockPage"></TransactionItems>
                                </table>
                            </div>
                        </div> */}
                    </TabPanel>
                </Tabs>
            </section>
        </div>
    )
}
